module.exports = __webpack_public_path__ + "img/hero-img@2x.24b93dfa.png";